import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugCapecitabine} from "./TextDrugCapecitabine"


export default function Capecitabine() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
 
    <ButtonsText onClick={handleOpen} name='Capecitabine' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Capecitabine - PGx Recommendation"
        content={ <TextDrugCapecitabine />}

        />

</>
)}